import { useFormaliteService } from '@europrocurement/l2d-domain';
import { DossierOpenSearchJsonldOpensearchDossierWorkingGroupRead } from '@europrocurement/l2d-domain/openApi/ApiFormalite';

export type DossierWorkGroup = DossierOpenSearchJsonldOpensearchDossierWorkingGroupRead &
    Record<string, unknown>;

const useDossierWorkGroup = () => {
    const { dossierOpenSearchApi } = useFormaliteService();
    let searchTimeout: number | undefined;

    const searchDossierWorkGroup = (term: string): Promise<Array<DossierWorkGroup>> =>
        new Promise((resolve, reject) => {
            clearTimeout(searchTimeout);
            const requestParameters = { q: term || undefined };

            searchTimeout = setTimeout(() => {
                dossierOpenSearchApi
                    .apiOpensearchWorkingGroupsGetCollection(requestParameters)
                    .then((res) => resolve(res.data['hydra:member'] as Array<DossierWorkGroup>))
                    .catch(() => reject());
            }, 300);
        });

    return { searchDossierWorkGroup };
};

export default useDossierWorkGroup;
